import { Download } from 'lucide-react';

interface DownloadPDFButtonProps {
  url: string;
  label?: string;
  placement?: 'top' | 'bottom';
}

export function DownloadPDFButton({ url, label, placement = 'top' }: DownloadPDFButtonProps) {
  const margin = placement === 'top' ? 'mb-8' : 'mt-12';
  const accessibleLabel = label ? `Download PDF: ${label}` : 'Download PDF';
  return (
    <div className={`not-prose ${margin} flex justify-start`}>
      <a
        href={url}
        download
        rel="noopener"
        aria-label={accessibleLabel}
        className="inline-flex items-center gap-2 bg-[#2D7E32] text-white font-semibold px-5 py-2.5 rounded-full hover:opacity-90 transition-opacity text-sm shadow-sm"
      >
        <Download className="h-4 w-4" aria-hidden="true" />
        Download PDF
      </a>
    </div>
  );
}
